module.exports = __webpack_public_path__ + "static/media/web3-vending-logo.b60e6423.png";